"use client";
import { UsersDetailsSkeletons } from "../../components/skeletons/users-skeletons";
import { Breadcrumb, Button, message, Select, Spin } from "antd";
import { ArrowLeft } from "lucide-react";
import moment from "moment";
import { useNavigate, useParams } from "react-router-dom";

import {
  useUpdateConsultationStatusServiceUpdate,
  useConsultationDetail,
} from "../../../hooks/api/consultation-bookings/hooks";
import { cn } from "../../../lib/utils";
import { IDocumentPayloadType } from "@src/types/api/document-types";
import DetailsSectionCard from "../../components/reuseComp/DetailsSectionCard";
import TwoColumnGrid from "../../components/reuseComp/TwoColumnGrid";
import { useDocumentDetail } from "../../../hooks/api/document/hooks";

const STATUS_OPTIONS = [
  { label: "Pending", value: "PENDING" },
  { label: "Approved", value: "APPROVED" },
  { label: "Cancelled", value: "CANCELLED" },
  { label: "Complete", value: "COMPLETED" },
];

const DocumentDetails = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const { data: documentDetails, isLoading } = useDocumentDetail(id ?? "");

  // const currentStatus = document?.data?.status ?? "PENDING";

  // const { mutate: updateStatus, isPending } =
  //   useUpdateConsultationStatusServiceUpdate({
  //     onSuccess: () => {
  //       console.log("inside" , "checkckc");
  //       message.success("Status updated successfully");
  //     },
  //     onError: (error: any) => {
  //       message.error(error.message);
  //     },
  //   });

  return (
    <div className="w-full">
      {/* TOP HEADER */}
      <div className="mb-6">
        <div className="flex justify-start w-full">
          <Button
            className="flex items-center gap-2 mb-2 cursor-pointer"
            onClick={() => navigate(-1)}
          >
            <ArrowLeft size={20} className="text-primary" />
            <span className="text-primary font-semibold">Back</span>
          </Button>
        </div>

        <h1 className="text-lg sm:text-3xl font-semibold sm:mb-1">
          Consultation Details
        </h1>

        <Breadcrumb
          separator=">"
          items={[
            { title: "Dashboard" },
            { title: "Consultation" },
            { title: "Consultation Details" },
          ]}
          className="text-xs sm:text-base"
        />
      </div>
      
    </div>
  );
};


export default DocumentDetails;
